import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface ChildCollection {
  collectionId: number
  collectionNo: string
  parentCollectionId: number | null
  parentCollectionNo: string | null
  holdingBranchCode: SystemCode
  shelfType: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
  revision: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  displayTitle: string
  sortTitle: string
  displayAuthor: string
  sortAuthor: string
  displayPublisher: string
  collectionFlag: CollectionFlag
}

export function ChildCollectionFromJSON(json: any): ChildCollection {
  return {
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    parentCollectionId:
      json.parent_collection_id !== undefined
        ? json.parent_collection_id
        : null,
    parentCollectionNo:
      json.parent_collection_no !== undefined
        ? json.parent_collection_no
        : null,
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    sortAuthor: exists(json, 'sort_author') ? json.sort_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection
  }
}
